import {inventoryTableRow} from "./types/index"

export const MOCK_MATERIALS: inventoryTableRow[] = [
    {
        materialNumber: "hnfyj-1",
        description: "INVENTORY.MATERIALS.STEEL_PLATE.description",
        inSupply: 45,
        preserved: 80
    },
    {
        materialNumber: "ghvh-2",
        description: "INVENTORY.MATERIALS.ALUMINUM_BEAM.description",
        inSupply: 30,
        preserved: 60
    },
    {
        materialNumber: "dfg-3",
        description: "INVENTORY.MATERIALS.RUBBER_SEAL.description",
        inSupply: 100,
        preserved: 90
    }
]